<template>
  <div style=" width: 100%;">
    <vxe-toolbar ref="xToolbar" print export>
      <template #buttons>
        <span> {{ getTotalMeg(totalRecords) }}</span>
      </template>
      <div slot="tools">
        <Popover :dataList="tabColumn" @saveCol='resetCol' />
      </div>
    </vxe-toolbar>
    <vxe-table v-if="!loading" border height="520" show-overflow align="center" class="mytable-style table-width"
      :cell-class-name="cellClassName" ref="table" :print-config="{}" :toolbar-config="tableToolbar"
      @cell-click="cellClick" @cell-dblclick="cellClick" @custom="customEvent" :row-style="rowStyle"
      :data="gridOptions.data" :auto-resize="true" :column-config="{ resizable: true }"
      @filter-visible="filterVisibleEvent" :scroll-y="{ enabled: true }" :row-config="{ height: 40 }"
      :cell-style="{ padding: '3px', 'font-size': '12px', 'line-height': '16px ' }">
      <vxe-column width="80">

        <template slot-scope="scope">
          <!-- <i :class="item.icon" :title="item.field" v-show="scope.row[item.field]"></i> -->
          <div class="flag">
            <div v-for="i in 3" :key="i">
              <i :class="getRowFlag(scope.row, i).icon" :title="getRowFlag(scope.row, i).title"></i>
            </div>
          </div>
        </template>
      </vxe-column>

      <vxe-column v-for="(item) in gridOptions.columns" :title="item.title" sortable :filters="getColumnList(item)"
        :field="item.field" :filter-method="filterMethod" show-header-overflow show-overflow="title"
        show-footer-overflow min-width="60" width="120">
        <template #filter="{ $panel, column }">
          <div style="padding: 10px; max-width: 260px;max-height: 320px;overflow: auto;">
            <el-input v-model="getFilterVal" size="mini" style="margin: 6px 0;" suffix-icon="el-icon-search"></el-input>
            <li v-for="(option, index) in getAllFilters(column)" :title="option.label" style="margin: 2px, 0">
              <el-checkbox v-model="option.checked" @change="$panel.changeOption($event, !!option.checked, option)">
                {{ option.label }}
              </el-checkbox>
            </li>
          </div>
        </template>
      </vxe-column>
    </vxe-table>

    <el-pagination small class="pagination" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="pageSizes"
      :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalRecords">
    </el-pagination>
  </div>
</template>

<script>
import axios from "axios";
import Popover from '../../../components/columnPopover.vue'

export default {
  data() {
    return {
      getFilterVal: '',
      checked: false,
      loading: false,
      tableShow: false,
      totalRecords: 0,

      pageSizes: [100, 200, 500, 1000],
      pageSize: 1000,
      currentPage: 1,

      seekId: 0,

      TagList: [],
      linkProperty: '',
      ll: [
        "el-icon-news",
        "el-icon-data-line",
        "el-icon-office-building",
        "el-icon-paperclip",
      ],
      colorList: ["#13ce66", "#fcad2c", "#F56C6C", "#38A8F6"],
      iconType: [],

      tableToolbar: {
        buttons: [{ code: "myInsert", name: "", type: "text" }],
        print: true,
        export: true,
        zoom: true,
        custom: true,
        slots: {
          tools: "tools",
        },
      },

      tabColumn: [],
      tempColumns: [],

      gridOptions: {
        id: "0",
        border: true,
        resizable: true,
        showOverflow: true,
        stripe: true,
        height: 600,
        align: "left",
        highlightHoverRow: true,
        // editConfig: { trigger: "dblclick", mode: "row" },
        exportConfig: { columnFilterMethod: this.columnFilter },
        columns: [],
        data: [],
        // customConfig: { storage: true },
      },
      rowStyle: { cursor: "pointer" },
    };
  },
  components: { Popover },
  props: ["data", "elementHeight", "searchInfo"],
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.currentPage = 1;
      this.$emit('changePagination', { 'pageSize': val, 'currentPage': 1 })
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.$emit('changePagination', { 'pageSize': this.pageSize, 'currentPage': val })

    },
    getRowFlag(row, index) {
      // console.log(row);
      const arr = [{ title: '历史变更', icon: 'el-icon-data-line' }, { title: 'BOM', icon: 'el-icon-news' }, { title: '附件', icon: 'el-icon-document' }];
      const { hasRev = 0, isBOM = 0, isFile = 0 } = row.ObjectId;
      const list = [hasRev, isBOM, isFile];
      const e = index - 1;
      const t = list[e];
      // const icon = t ?  arr[e].icon : 'holder';
      let { title, icon } = arr[e]
      icon = t ? icon : 'holder'
      const str = t ? '有' : '无'
      return { icon, title: str + title }
    },
    getTotalMeg(n) {
      return this.$t('message.title.totalResults') + n + this.$t('message.title.resultsNums');
    },
    setColumnsKey(item) {
      const n = this.gridOptions.columns.length + '';
      return n + item.field;
    },
    getAllFilters(column) {
      if (this.getFilterVal === "") {
        return column.filters
      }
      const arr = column.filters.filter(i => i.label.indexOf(this.getFilterVal) != -1)
      return arr
    },
    filterVisibleEvent({ column, visible }) {
      !visible && (this.getFilterVal = '')
    },

    getColumnList(item) {
      console.log(item);

      const list = this.gridOptions.data.map(i => i[item.field]);
      const arr = [...new Set(list)].map((i, e) => ({ checked: false, data: i, label: i, value: i }))
      return arr
    },
    filterMethod({ column, row, value }) {
      // console.log({ option, row });
      return row[column['field']] == value
    },

    // exportEvent
    // cc() {
    //   this.$refs.table.exportData({
    //     filename: 'export',// 文件名字
    //     sheetName: 'Sheet1',
    //     type: 'xlsx',//导出文件类型 xlsx 和 csv
    //     data: this.exportdata, // 数据源
    //     // 过滤那个字段导出
    //     columnFilterMethod: function(column, $columnIndex) {
    //       console.log(column);
    //       // return !(column.$columnIndex === 0 )
    //       // 0是复选框 不导出
    //       return !["pendingChangeTag","BOMTag","manufacturerTag","attachmentTag"].includes(column.title)
    //     }
    //   })
    // },
    resetCol(e) {
      // console.log(e)
      const [col, All] = e;
      console.log(e);

      const arr = [];
      All.map((i, e) => {
        const { title } = i
        if (col.includes(title)) {
          const obj = this.tempColumns.find(j => j.title === title);
          arr.push(obj)
        }
      })
      const allCol = All.map(i => i.title)
      console.log(arr, arr.map(i => i.title));
      // this.gridOptions.columns = arr;
      this.$set(this.gridOptions, 'columns', arr)
      const str = col.join(';') + '__' + allCol.join(';');
      console.log({ All, str });
      this.saveColumnsRes(str)

    },
    saveColumnsRes(str) {

      let seekVo = {
        ...this.searchInfo,
        saveColumns: str,
        isPublic: 10,
        name: Date.now() + "",
      };
      this.seekId && Object.assign(seekVo, { id: this.seekId });

      axios
        .post("/search/advanced/saveSeek", { seekVo })
        .then((res) => {
          this.seekId = res.data.object.result.id;
        })
        .catch((_) => { });
    },
    rowClick(row, column, event) {

      const obj = {
        ...row.ObjectId,
        title: row[0]
      }
      this.getLink(obj);
    },
    columnFilter({ column, $columnIndex }) {
      // console.log({ column, $columnIndex });
      return true;
      // return column.filter(i => !["pendingChangeTag","BOMTag","manufacturerTag","attachmentTag"].includes(column.property))
      // return !["pendingChangeTag","BOMTag","manufacturerTag","attachmentTag"].includes(column.property)
    },

    cellClick({ row, column }) {
      console.log(column.property, this.linkProperty);
      if (column.property == this.linkProperty) {
        this.rowClick(row);
      }
    },
    cellClassName({ row, rowIndex, column, columnIndex }) {
      // console.log(column.property);
      // console.log(this.linkProperty, column.property == this.linkProperty);
      if (column.property == this.linkProperty) {
        return "link_";
      }
    },

    customEvent({ type, $table }) {
      if (type != "confirm") {
        return;
      }
      const currentColumns = $table.getColumns().map((i) => i.property);
      const saveColumns = $table.tableFullColumn
        .filter((i) => !currentColumns.includes(i.property))
        .map((i) => i.property)
        .join(";");
      let seekVo = {
        ...this.searchInfo,
        saveColumns,
        isPublic: 10,
        name: Date.now() + "",
      };
      this.seekId && Object.assign(seekVo, { id: this.seekId });

      axios
        .post("/search/advanced/saveSeek", { seekVo })
        .then((res) => {
          console.log(res);
          this.seekId = res.data.object.result.id;
        })
        .catch((_) => { });
    },

    getItemData(data) {
      console.log(data);
      let columnlist = [];

      this.seekId = data["tableP1"]?.seekId;
      this.seekColumns = data["tableP1"]?.saveColumns ?? "";

      console.log(Object.values(data));
      let arr = Object.values(data)
        .filter((i) => i.tableID)
        .sort((a, b) => {
          return b.tableID - a.tableID;
        });
      console.log(arr);
      let dataRows = arr.map((item) => {
        let tempRow = [];
        const n = item.columnInfo.names.map((i, e) => ({
          title: i,
          field: item.columnInfo.ids[e].toString(),
          // minWidth: "60",
          sortable: true,
        }));
        columnlist = [...n, ...columnlist];
        item.rows.map((j) => tempRow.push(j.cells));
        return tempRow;
      });
      dataRows = dataRows.filter((i) => !!i.length);
      // this.totalRecords = dataRows.length;

      if (!dataRows.length) {
        this.totalRols = dataRows.length;
        this.tableToolbar.buttons[0].name = this.getTotalMeg(this.totalRecords)

        this.tableShow = true;
        this.loading = false;
        this.$emit('done')
        return;
      }
      let newArray = dataRows[0].map(function (col, i) {
        return dataRows.map(function (row) {
          return row[i];
        });
      });
      // console.log(newArray);
      let tempArr = newArray.map((i) => {
        let arr = [];
        i.map((j) => {
          let n = j || [];
          return (arr = [...n, ...arr]);
        });
        return arr;
      });

      let iconColumn = [];

      let ObjectIdList = data["tableP1"].rows.map((i) => {
        const name = i.cells[0].val;
        const {
          objSubClass: subClassId,
          objClass: classId,
          objId: id,
          baseClass: baseClassId,
          hasRev = 0,
          isBOM = 0,
          isFile = 0
        } = i;
        const arr = { id, classId, subClassId, name, hasRev, isBOM, isFile };
        return arr;
      });

      let listData = tempArr.map((i) => {
        let temp = {};
        i.map((j, e) => {
          Object.assign(temp, { [columnlist[e].field]: j?.val || '' });
        });
        return temp;
      });
      listData.map((i, e) => {
        // if (iconColumn.length) {
        //   i.preList = iconColumn[e];}
        Object.assign(i, iconColumn[e]);
        i.ObjectId = ObjectIdList[e];
      });

      const nameClick = ({ row, column }) => {
        return [
          <span class="link_" onClick={() => this.rowClick(row, column)
          }>
            {" " + row[column.property] + ""}
          </span>]
      };

      columnlist[0].slots = {
        default: nameClick,
      };
      console.log(columnlist);

      this.linkProperty = columnlist[0].field;
      this.gridOptions.columns = [...columnlist];

      this.tempColumns = [...columnlist];

      const saveCol = data.tableP1.saveColumns
      // debugger
      if (!saveCol || !saveCol.includes('__')) {
        const list = this.tempColumns;
        const checked = list.map(i => i.title);
        this.tabColumn = { checked, All: list }
      } else {

        const [tempCheck, All] = saveCol.split('__');

        const checked = tempCheck.split(';');
        const list = All.split(';').map(i => {
          const obj = this.tempColumns.find(j => j.title === i)
          return obj
        }).filter(i => !!i)
        this.tabColumn = { checked, All: list }
      }


      this.gridOptions.data = listData;
      this.visiableData = listData;
      this.totalRols = listData.length;
      this.tableToolbar.buttons[0].name = this.getTotalMeg(this.totalRecords)
      this.tableShow = true;
      this.loading = false;
      this.$emit("done");

    },
    setColumns() {
      // console.log(this.seekColumns);
      console.log(this.tabColumn);
      const { checked, All = [] } = this.tabColumn;

      let arr = [];
      All.map((i, e) => {
        if (checked.includes(i.title)) {
          // const obj =  this.tempColumns.find(j => j.title === i);
          // arr.push(obj)
          arr.push(i)
        }
      })
      this.gridOptions.columns = [...arr];

    },

    showTable(data1) {
      this.gridOptions.columns = [];
      this.gridOptions.data = [];
      this.TagList = [];
      this.iconType = [];
      this.seekColumns = '';
      // console.log(this.data);

      console.log(this.searchInfo);
      this.gridOptions.id = Object.values(this.searchInfo).join();
      if ([101, 104, 105, 301, 401, 501].includes(this.searchInfo.baseId)) {
        let data = {};
        Object.keys(this.data).map((i) => {
          if (i != "page") {
            data[i] = this.data[i];
          } else {
            this.totalRecords = this.data["page"].totalCount;
          }
        });
        this.getItemData(data);
        !this.loading &&
          this.$nextTick(() => {
            this.setColumns();
            this.currentPage = data1?.page?.currentPage || 1
          });
      } else {
        console.log('22222222');
        this.getTableData();
      }

    },

    getTableData() {
      console.log(this.data);
      let rows = this.data.table?.rows;
      if (!rows?.length) {
        this.loading = false;
        this.totalRecords = 0;
        this.tableToolbar.buttons[0].name = this.getTotalMeg(this.totalRecords)
        this.$emit("done");
        return false;
      }
      // this.loading = true;
      this.totalRecords = this.data.page.totalCount;
      this.tableToolbar.buttons[0].name = "";

      // this.missingRows = res.table.rowMissing;
      let table_title = this.data.table.columnInfo.names;
      let columns = table_title.map((i, e) => {
        return { title: i, field: e + "", sortable: true };
      });

      const nameClick = ({ row, column }) => {
        return [
          <span class="link_" onClick={() => this.rowClick(row, column)
          }>
            {" "}
            {row[column.property]} {" "}
          </span>,
        ];
      };
      columns[0].slots = {
        default: nameClick,
      };
      this.linkProperty = columns[0].field;

      this.gridOptions.columns = columns;
      this.tableToolbar.buttons[0].name = this.getTotalMeg(this.totalRecords)

      this.gridOptions.data = rows.map((i) => {
        let {
          objSubClass: subClassId,
          objClass: classId,
          objId: id,
          baseClass: baseClassId,

        } = i;
        let e = i.cells.map((j) => j.val || "");
        let row = { ...e };
        row.ObjectId = { id, classId, subClassId };
        return row;
      });
      // console.log(this.gridOptions.data);
      this.loading = false;
      this.$emit("done");

    },
  },
  mounted() {
    // this.showTable(this.data);
    // console.log('1111111111',this.elementHeight,);
    this.gridOptions.height = this.elementHeight;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      // this.$refs.table.connect(this.$refs.xToolbar);
      this.setColumns();
    });
  },
  created() { },
  watch: {
    data: {
      //监听父组件的状态改变按钮，修改完状态刷新页面
      handler(val) {
        this.showTable(val);
      },
      deep: true,
      // immediate: true,
    },
  },
};
</script>


<style lang="scss" scoped>
.table-width {
  width: 100%;
  table-layout: fixed;
}

.table-width ::v-deep(.vxe-table--render-default) {
  height: 26px;
}

.pro-title {
  font-size: 14px;
}

.flag {
  column-count: 3;
  column-gap: 6px;
  cursor: pointer;
}

.holder {
  width: 40px;
  height: 16px;
  /* background: #4b92ff; */
  display: block;
  /* border: 1px solid #fff; */
  /* border: #4b92ff 1px solid; */
}

.proxx {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background: white;
  display: inline-block;
  margin-right: 3px;
}

.circle {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  display: inline-block;
  margin-right: 2px;
}

.link_ {
  /* text-decoration: underline; */
  color: #409eff;
  cursor: pointer;

  &::v-deep .vxe-cell--label {
    border-bottom: #409eff 1px solid;
  }

}
</style>
